import { styled } from '@nextiva/next-ui-components';

export const StyledGlobalHeaderContainer = styled('div')(({ theme }) => ({
  height: theme.spacing(7),
  backgroundColor: 'white',
}));